module.exports = __webpack_public_path__ + "static/seo-everypig-7aae4ab0277f0d815a75915d60a11d0a.png";